/* eslint-disable react/prop-types */
import React, { useState, SFC, useEffect, useRef } from "react";
import {
    Card,
    Grid,
    Box,
    Typography,
    TextField,
    Button,
    GridJustification,
    useTheme,
    useMediaQuery,
    PropTypes as MuIPropTypes,
    CircularProgress
} from "@material-ui/core";
import {TextField as RTextField} from "formik-material-ui";
import { makeStyles } from "@material-ui/core/styles";
import { Formik, Form, Field, FieldArray } from "formik";
import * as Yup from "yup";
import { useSnackbar } from "notistack";
import { useHistory } from "react-router-dom";
import { colorBorder } from "../../Constants/theme";
import { Location } from "../Location";
import { ReactComponent as DocSVG } from "../../Images/vetDoctor.svg";
import { ReactComponent as PencilSVG } from "../../Images/pencil.svg";
import Api from "../../helpers/apiHelpers";
import UploadPhoto from "../Modals/UploadPhoto";
import MenuItem from "@material-ui/core/MenuItem";
import {specialities} from "../../Constants/specialities";
import {getProfileURLUploadImage, getUserProfile, patchUserProfile} from "../../redux/userProfile/userProfile.actions";
import {RootState, useAppDispatch} from "../../redux/store";
import {useSelector} from "react-redux";
import AddLiscenses from "../AddLiscenses";
import ModalImage from "react-modal-image";
import LaunchIcon from "@material-ui/icons/Launch";
import CancelIcon from "@material-ui/icons/Cancel";
import Autocomplete from "@material-ui/lab/Autocomplete";

interface Props {
	setIsOnBoarding: any,
	isOnBoarding: boolean,
}

const useStyle = makeStyles(() => ({
    wrapper: {
        padding: "1.5em"
    },
    inputGrpup: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between"
    },
    clickable: {
        cursor: "pointer",
    },
    marginLeft: {
        marginLeft: "1em"
    },
    marginBottom: {
        marginBottom: "1em"
    },
    timeWrapper: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        flexWrap: "wrap",
    },
    headerPadding: {
        marginBottom: "2em",
        marginTop: "2em"
    },
    stateFieldStyles: {
        height: 40,
        width: "100%",
        zIndex: 999
    },
    stateInputStyles: {
        width: "100%",
    },
    disallowSpacingVerticalPadding: {
        "& > div": {
            paddingTop: "40px !important",
            paddingBottom: "0px !important",
        }
    },
    workDaysCheckboxLabel: {
        minWidth: 140,
    },
    feeInputs: {
        maxWidth: 100,
        marginRight: "2em",
        marginTop: "1em"
    },
    img: {
        height: 100,
        objectFit: "cover"
    },
    closeIcon: {
        position: "absolute",
        top: -10,
        right: -10,
        zIndex: 99,
        cursor: "pointer"
    }
}));

const Main: SFC<Props> = ({ isOnBoarding, setIsOnBoarding }: Props) => {
    const classes = useStyle();
    const [profileId, setProfileId] = useState();
    const [squareAuthButtonVisibility, setSquareAuthButtonVisibility] = useState(false);
    const [uploadPhotoModalVisibility, setUploadPhotoModalVisibility] = useState(false);
    const [isLoading, setIsloading] = useState(true);
    const [profile, setProfile] = useState(null);
    const [uploadImageURL, setUploadImageURL] = useState("");
    const [initialValues, setInitialValues] = useState({
        firstName: "",
        lastName: "",
        education: "",
        workingStates: [],
        speciality: [],
        brief: "",
        image: null,
    });
    const [uploadFile, setUploadFile] = useState(null);
    const theme = useTheme();
    const { enqueueSnackbar } = useSnackbar();
    const history = useHistory();
    const dispatch = useAppDispatch();
    const user = useSelector((state: RootState) => state?.user);
    const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
    let justifyResonsiveStart: GridJustification = isMobile ? "center" : "flex-start";
    const textAlignmentAdaptive: MuIPropTypes.Alignment = isMobile ? "center" : "left";
    const [loaded, setLoaded] = useState(false);
    const [licenses, setLicenses] = useState([]);

    const validationSchema = Yup.object().shape({
        firstName: Yup.string().required("Required"),
        lastName: Yup.string().required("Required"),
    });

    const imageRef = useRef(null);
    const [image, setImage] = useState("");
    const [linkToSquareOauth, setLinkToSquareOauth] = useState("");
    const handleImageLoadError = () => {
        setImage("");
    };

    const handleClickAddState = (values) => {
        setInitialValues({ ...values, workingStates: [...values.workingStates , ""] });
    };

    const handleClickAddSpeciality = (values) => {
        setInitialValues({ ...values, speciality: [...values.speciality , ""] });
    };

    const handleRemoveImage = async (item) => {
        const newList = licenses.filter(license => license !== item);
        setLicenses(newList);
        let imgId = item.split("?")[0].split("/").filter(str => str.includes(".img"))[0].match(/\d+/)[0];
        //Remove license
        const resp = await Api.deleteLicense(profileId,imgId);
    };

    useEffect(() => {
        Api.getSquareoauth()
            .then((res) => {
                if (Object.prototype.hasOwnProperty.call(res,"practiceCode")){
                    Api.getSquareOauthLink()
                        .then((link) => {
                            setLinkToSquareOauth(link);
                            //setSquareAuthButtonVisibility(true);
                        });
                }else {
                    setSquareAuthButtonVisibility(false);
                }
            });
    }, []);

    //THIS is to reload the lisense photos
    useEffect(() => {
        if (loaded === true) {
            dispatch(getUserProfile({userId: user.userId}))
                .then((profiles) => {
                    if (profiles.length) {
                        setLicenses(profiles[0].licenseUrl);
                    }
                });
            setLoaded(false);
        }
    }, [loaded]);

    useEffect(() => {
        dispatch(getUserProfile({userId: user.userId}))
            .then((profiles) => {
                if (profiles.length) {
                    setProfile(profiles[0]);
                    setProfileId(profiles[0].id);
                    dispatch(getProfileURLUploadImage(profiles[0].id))
                        .then((res) => {
                            setUploadImageURL(res.uploadUrl);
                            setImage(res.downloadUrl);
                        })
                        .catch((err) => {
                            enqueueSnackbar(err, {variant: "error"});
                        });
                    const newValues = {
                        firstName: profiles[0]?.firstName || "",
                        lastName: profiles[0]?.lastName || "",
                        speciality: profiles[0]?.speciality?.map(el => specialities.find(item => item.value === el)) || [],
                        education: profiles[0]?.education || "",
                        workingStates: profiles[0]?.workingStates?.length ? profiles[0].workingStates.filter(Boolean)  : [""],
                        brief: profiles[0]?.summary || "",
                        image: profiles[0]?.image || null,
                    };
                    setLicenses(profiles[0].licenseUrl || []);
                    setInitialValues({ ...initialValues, ...newValues });
                }
            });
        setIsloading(false);
    }, []);
    return (
        <Box>
            <Formik
                initialValues={initialValues}
                enableReinitialize={true}
                onSubmit={async (values) => {
                    try {
                        const {
                            workingStates,
                            firstName,
                            lastName,
                            education,
                            brief,
                            speciality
                        } = values;
                        dispatch(patchUserProfile({id: profileId, body: {
                            type: "vet",
                            firstName: firstName,
                            lastName: lastName,
                            education: education,
                            summary: brief,
                            workingStates: workingStates,
                            speciality: speciality.map(el => el.value),
                            licenseUrl: licenses
                        }}));
                        enqueueSnackbar("The profile is updated");
                        if (isOnBoarding) {
                            setIsOnBoarding(false);
                            history.push({
                                pathname: "/appointments",
                            });
                        }
                    } catch (error) {
                        enqueueSnackbar(error.message || error.message[0], {
                            variant: "error",
                            autoHideDuration: 3000,
                        });
                    }
                }}
                validationSchema={validationSchema}
            >
                {(props) => (
                    isLoading?
                        <Card variant="outlined" className={classes.wrapper}>
                            <Box display="flex" justifyContent="center">
                                <CircularProgress />
                            </Box>
                        </Card>
                        :
                        <Form>
                            <Card variant="outlined" className={classes.wrapper}>
                                <Typography variant="h4" className={classes.headerPadding}>Veterinarian Profile</Typography>
                                {
                                    squareAuthButtonVisibility &&
									<Button
									    onClick={() => {
									        window.open(linkToSquareOauth, "_blank");
									    }}
									    style={{display: "flex", alignItems: "center", justifyItems: "center"}}
									>
									    <Typography style={{paddingRight: 5}}>Connect square</Typography><LaunchIcon fontSize="small" color="primary"/>
									</Button>
                                }
                                <Grid container>
                                    <Grid item container justify={justifyResonsiveStart} xs={12} sm={4}>
                                        <Box marginBottom="10px" position="relative" display="flex" justifyContent="center">
                                            <Box
                                                position="absolute"
                                                right="-10px"
                                                bottom="-9px"
                                                borderRadius="50%"
                                                bgcolor={colorBorder}
                                                width="21px"
                                                height="21px"
                                                display="flex"
                                                justifyContent="center"
                                                alignItems="center"
                                                className={classes.clickable}
                                                onClick={() => { setUploadPhotoModalVisibility(true); }}
                                            >
                                                <PencilSVG />
                                            </Box>
                                            {image ?
                                                <Card style={{maxWidth: 130}}>
                                                    <img
                                                        ref={imageRef}
                                                        src={image}
                                                        onError={handleImageLoadError}
                                                        width="130"
                                                        height="130"
                                                        style={{objectFit: "cover"}}
                                                    ></img>
                                                </Card> : <DocSVG />}
                                        </Box>
                                    </Grid>
                                    <Grid item container alignItems="center" xs={12} sm={8}>
                                        <Grid item container alignItems="center" xs={12} style={{marginBottom: 7}}>
                                            <Typography
                                                variant="body2"
                                                align={textAlignmentAdaptive}
                                                className={`${isMobile ? classes.marginBottom : ""}`}
                                            >
												Name
                                            </Typography>
                                        </Grid>
                                        <Grid item container alignItems="flex-start" xs={12} sm={12}>
                                            <Grid item xs={12} sm={6}>
                                                <Field
                                                    component={RTextField}
                                                    variant="outlined"
                                                    name="firstName"
                                                    className={`${isMobile ? classes.marginBottom : ""}`}
                                                    fullWidth={isMobile}
                                                    placeholder=""
                                                    label="First name"
                                                    size="medium"
                                                    onChange={props.handleChange("firstName")}
                                                    onBlur={props.handleBlur("firstName")}
                                                    value={props.values.firstName}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <Field
                                                    component={RTextField}
                                                    variant="outlined"
                                                    name="lastName"
                                                    className={`${isMobile ? classes.marginBottom : classes.marginLeft}`}
                                                    fullWidth={isMobile}
                                                    placeholder=""
                                                    size="medium"
                                                    label="Last name"
                                                    onChange={props.handleChange("lastName")}
                                                    onBlur={props.handleBlur("lastName")}
                                                    value={props.values.lastName}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid container>
                                            <Grid item container alignItems="center" xs={12} style={{marginTop: 10, marginBottom: 5}}>
                                                <Typography
                                                    variant="body2"
                                                    align={textAlignmentAdaptive}
                                                    className={`${isMobile ? classes.marginBottom : ""}`}
                                                >
													Edu.
                                                </Typography>
                                            </Grid>
                                            <Grid item container alignItems="center" xs={12}>
                                                <Field
                                                    component={TextField}
                                                    variant="outlined"
                                                    name="education"
                                                    fullWidth
                                                    className={`${isMobile ? classes.marginBottom : ""}`}
                                                    size="medium"
                                                    placeholder="Where did you receive your education from?"
                                                    onChange={props.handleChange("education")}
                                                    value={props.values.education}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid container style={{marginTop: 10}}>
                                    <Grid item container justify={justifyResonsiveStart} className={classes.headerPadding} xs={12}>
                                        <Typography
                                            variant="body2"
                                            align={textAlignmentAdaptive}
                                        >
											Species Treated
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} >
                                        <Autocomplete
                                            multiple
                                            fullWidth={true}
                                            getOptionLabel={(option) => option.label}
                                            renderInput={(params) => <TextField {...params} variant="outlined" />}
                                            options={specialities}
                                            //@ts-ignore
                                            value={specialities.filter(type => props.values.speciality.find(el => el?.value === type?.value)) || []}
                                            //@ts-ignore
                                            onChange={(event, value) => {
                                                props.setFieldValue("speciality", value);
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                                <Typography variant="h4" className={classes.headerPadding}>Bio</Typography>
                                <Grid container >
                                    <Grid item container justify="center" xs={12}>
                                        <Field
                                            component={TextField}
                                            variant="outlined"
                                            multiline
                                            rows={5}
                                            fullWidth
                                            name="brief"
                                            onChange={props.handleChange("brief")}
                                            value={props.values.brief}
                                            placeholder="Couple of words about yourself"
                                        />
                                    </Grid>
                                </Grid>
                                <Typography variant="h4" className={classes.headerPadding}>Active License(s)</Typography>
                                <Box display="flex" flexWrap="wrap" justifyContent="space-between" className={classes.marginBottom}>
                                    {licenses.map((item) => {
                                        return (
                                            <Box height="120px" key={item} position="relative">
                                                <CancelIcon className={classes.closeIcon} color="error" onClick={() => handleRemoveImage(item)}/>
                                                <ModalImage
                                                    small={item}
                                                    large={item}
                                                    className={classes.img}
                                                />
                                            </Box>

                                        );
                                    })}
                                    {profileId &&
										<AddLiscenses vetId={profileId} profile={profile} setLoaded={setLoaded}/>
                                    }
                                </Box>
                                <Box display="flex" justifyContent="flex-end" style={{marginTop:10}}>
                                    <Button variant="contained" color="secondary" type="submit">Save</Button>
                                </Box>
                            </Card>
                        </Form>
                )}
            </Formik>
            {
                uploadImageURL &&
				<UploadPhoto
				    onClose={() => { setUploadPhotoModalVisibility(false); }}
				    isOpen={uploadPhotoModalVisibility}
				    imageUploadURL={uploadImageURL}
				    onLoad={(val) => {
				        setUploadFile(val);
				        setUploadPhotoModalVisibility(false);
				        dispatch(getProfileURLUploadImage(profileId))
				            .then((res) => {
				                setUploadImageURL(res.uploadUrl);
				                setImage(res.downloadUrl);
				            })
				            .catch((err) => {
				                enqueueSnackbar(err, {variant: "error"});
				            });
				    }}
				/>
            }
        </Box>
    );
};

export default Main;
